// @flow
import React from 'react';

import { BaseHeading } from './BaseHeading';

export const StyledH5 = ({ text, inline = false }) => (
  <BaseHeading as="h5" inline={inline} text={text} />
);
